import type { CandidateEditableProfileDto } from "@artha/api-contracts";
import type { ResumeReviewForm } from "./personalization.types";

export const EMPTY_REVIEW_FORM: ResumeReviewForm = {
  name: "",
  email: "",
  phone: "",
  titles: "",
  skills: "",
  keywords: "",
};

export const toReviewForm = (
  profile: CandidateEditableProfileDto,
): ResumeReviewForm => ({
  name: profile.name,
  email: profile.email,
  phone: profile.phone,
  titles: profile.titles.join(", "),
  skills: profile.skills.join(", "),
  keywords: profile.keywords.join(", "),
});

const parseList = (value: string) => {
  const seen = new Set<string>();
  return value.split(",").reduce<string[]>((items, entry) => {
    const clean = entry.trim();
    const key = clean.toLowerCase();
    if (clean && !seen.has(key)) {
      seen.add(key);
      items.push(clean);
    }
    return items;
  }, []);
};

export const toEditableProfile = (
  form: ResumeReviewForm,
): CandidateEditableProfileDto => ({
  name: form.name.trim(),
  email: form.email.trim().toLowerCase(),
  phone: form.phone.trim(),
  titles: parseList(form.titles),
  skills: parseList(form.skills),
  keywords: parseList(form.keywords),
});

export const PERSONALIZATION_FIELD_CLASS_NAME =
  "h-11 w-full rounded-[10px] border border-black bg-white px-3 text-sm text-[#101828] outline-none focus:ring-2 focus:ring-[#F8D96B]";
